/* eslint-disable no-mixed-operators */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Divider, Grid, Rating, Typography, useMediaQuery } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
//
import { BtnAddForm, BtnBack, BtnConfirm, BtnHome, BtnRecycle, BtnRejectPart, BtnSave, BtnSend, BtnUpdate } from 'components/Common/Button';
import { AlertMsgTh, AlertTitleTh, AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import CpnDataRequest from '../ComponentVOC/CpnDataRequest';
import CpnTypeRequestComplaint from '../ComponentVOC/CpnTypeRequestComplaint';
import CpnStatusVOC from '../ComponentVOC/CpnStatusVOC';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import CpnPopUpMap from '../ComponentVOC/CpnPopUpMap';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import moment from 'moment';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BiEdit } from "react-icons/bi";
import VerticalStepper from 'components/Stepper/VerticalStepper';
import CpnDataProductService from '../ComponentVOC/CpnDataProductService';
import CpnTypeRequest from '../ComponentVOC/CpnTypeRequest';
import CpnListProductService from '../ComponentVOC/CpnListProductService';
import CardBox from 'components/CardBox/CardBox';
import { AiFillWechat } from "react-icons/ai";
import { FaBell } from "react-icons/fa";
import ModalInformInprogress from '../ComponentVOC/ModalInformInprogress';
import ModalRejectPart from '../ComponentVOC/ModalRejectPart';
import CpnTypeRequestResolve from '../ComponentVOC/CpnTypeRequestResolve';
import CpnNote from '../ComponentVOC/CpnNote';
import { onCheckDataResponPIS } from '../ComponentVOC/CpnFunction';
import CpnResponPersonNew from '../ComponentVOC/CpnResponPerson_new';
import CpnAlertEmail from '../ComponentVOC/CpnAlertEmail';
import Accordion from 'components/Common/Accordion/Accordion';
import ModalWorkflowHistory from '../ComponentVOC/ModalWorkflowHistory';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import secureLocalStorage from 'react-secure-storage';

const PageProductAndService = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout1300 = useMediaQuery('(min-width:1300px)');

    //useState
    const [schemaObj, setSchemaObj] = useState({} as any);

    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null)
    const [sJobCode, setsJobCode] = useState(location?.state ? location.state["sJobCode"] : null)
    const [sMode, setsMode] = useState(location?.state ? location.state["sMode"] : null)  //Edit, View, Super
    const [sStatusForm, setsStatusForm] = useState(null)
    const [nAlertCount, setnAlertCount] = useState(0)
    const [sCustomer, setsCustomer] = useState("")
    const [sRefVOCCode, setsRefVOCCode] = useState("")

    const [nStatusID, setnStatusID] = useState(1)
    const [nHistoryStatusID, setnHistoryStatusID] = useState(0)
    const [DataRowProductService, setDataRowProDuctService] = useState([] as any)
    const [DataRowResolveRequest, setDataRowResolveRequest] = useState([] as any)       //List Note
    const [DataRowResolve, setDataRowResolve] = useState([] as any)       //List Note
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const [lstPrd_BA, setlstPrd_BA] = useState([] as any)
    //ModalInform Inprogress
    const [IsOpenModalInform, setIsOpenModalInform] = useState(false)
    const [DataRowInprogress, setDataRowInprogress] = useState([] as any)       //List Note    //#region  state component CpnDataRequest
    //#region  state component CpnDataRequest
    const onClearFile = useRef(null);
    const onClearFileResolveRequest = useRef(null);
    const onClearFileResolve = useRef(null);

    const [arrAttachment, setarrAttachment] = useState([] as any)
    const [arrFileResolveRequest, setarrFileResolveRequest] = useState([] as any)
    const [arrFileResolve, setarrFileResolve] = useState([] as any)

    const [IsCheckTel, setIsCheckTel] = useState(false)
    const [IsOtherVOCService, setIsOtherVOCService] = useState(false)
    const [IsAddAddress, setIsAddAddress] = useState(false)
    const [IshaveResponEmp, setIshaveResponEmp] = useState(false)
    const [IsOtherRequest, setIsOtherRequest] = useState(false)

    const [isInputTelRequire, setisInputTelRequire] = useState(false)
    const [IsOpenRejectPart, setIsOpenRejectPart] = useState(false) // ผจ.ส่วน Reject

    const [IsReferVOC, setIsReferVOC] = useState(false)
    const [IsCreateByBA, setIsCreateByBA] = useState(true)
    const [IsEmpRespon, setIsEmpRespon] = useState(false)
    const [IsEmpResponVOC, setIsEmpResponVOC] = useState(false)
    const [IsBAowner, setIsBAowner] = useState(false)
    const [IsSuperAdmin, setIsSuperAdmin] = useState(false)
    const [IsBAAdmin, setIsBAAdmin] = useState(false)
    const [IsRoleDM, setIsRoleDM] = useState(false)
    const [IsRoleVP, setIsRoleVP] = useState(false)
    const [IsAllowEmailAlert, setIsAllowEmailAlert] = useState(false)
    const [IsOpenModalWorkFlowHis, setIsOpenModalWorkFlowHis] = useState(false)
    const [IsAddTelExtentionGuest, setIsAddTelExtentionGuest] = useState(false)
    const [isInputTelRequireGuest, setisInputTelRequireGuest] = useState(false)

    const [IsOtherExternalPTT, setIsOtherExternalPTT] = useState(false)
    const [sTypeResponPerson, setsTypeResponPerson] = useState("22")
    const [sResponPerson, setsResponPerson] = useState('25')
    const [objPermission, setobjPermission] = useState(null as any)
    const [sCustomerType, setsCustomerType] = useState("C")
    const [objScore, setobjScore] = useState({
        lstQ: [],
        sSuggestion: "-",
        isShow: false
    })
    //#endregion
    //#region  state component CpnTypeRequestComplaint
    const [Option, setOption] = useState({
        lstBA: [],
        lstCompany: [],
        lstCompanyAddress: [],
        lstVOCType: [],
        lstVOCService: [],
        lstTel: [],
        lstContactType: [],
        lstTypeResolve: [],
        lstTypeRequest: [],
        lstOutPTT: [],
        lstTypeResponPerson: [],
        lstResponPerson: [],
        lstStatus: [],
    })
    //State Map

    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": [],
        "lstRoleUser": [],
    })

    //#region  Form
    let objSchema = {
        //1
        sJobCode: yupFormSchemas.object("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        sReferVOCFormCode: yupFormSchemas.object("เลขที่ใบแจ้งอ้างอิง", { required: false }),
        sDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
        oCustomer: yupFormSchemas.object("ลูกค้า", { required: false }),
        oBA: yupFormSchemas.object("กลุ่มตลาด", { required: [3, 19, 20].includes(nStatusID) ? false : true }),
        oCompany: yupFormSchemas.object("บริษัท", { required: false }),
        oAddress: yupFormSchemas.object("ที่อยู่", { required: false }),
        sAddress: yupFormSchemas.string("ที่อยู่", { required: false }),
        // sAddress: yupFormSchemas.string("ที่อยู่", { required: IsAddAddress }),
        oTel: yupFormSchemas.object("หมายเลขโทรศัพท์", { required: false }),
        sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: isInputTelRequire }),
        sInputTelExtension: yupFormSchemas.string("เบอร์ต่อ", { required: false }),
        sDateIssue: yupFormSchemas.string("วันที่แจ้ง", { required: false }),
        sTimeIssue: yupFormSchemas.string("เวลาที่แจ้ง", { required: false }),
        sNoticeEmail: yupFormSchemas.string("ส่งอีเมลแจ้งเตือนลูกค้า", { required: [3, 19, 20].includes(nStatusID) ? false : true }),
        //2
        oTypeRequest: yupFormSchemas.object("ประเภทข้อร้องขอ", { required: [3, 19, 20].includes(nStatusID) ? false : true }),
        sRequestTypeOther: yupFormSchemas.string("ประเภทข้อร้องขอ (อื่นๆ)", { required: IsOtherRequest }),
        //3
        sTypeResponPerson: yupFormSchemas.string("ประเภทผู้รับผิดชอบ", { required: [3, 19, 20].includes(nStatusID) ? false : true }),
        sResponPerson: yupFormSchemas.string("ผู้รับผิดชอบ", { required: [3, 19, 20].includes(nStatusID) ? false : true }),
        oAutoUnitInGBU: yupFormSchemas.object("หน่วยงาน", { required: sTypeResponPerson === "22" && sResponPerson === "25" ? true : false }),
        oAutoEmpInGBU: yupFormSchemas.object("ผู้รับผิดชอบแก้ไข", { required: (([0, 1, 2].includes(nStatusID) && sResponPerson === "26") || [3].includes(nStatusID) && IsRoleDM) && sTypeResponPerson === "22" ? true : false }),   //ผจ.ส่วน
        oAutoUnitInPTT: yupFormSchemas.object("หน่วยงาน", { required: sTypeResponPerson === "23" && sResponPerson === "25" ? true : false }),
        oAutoEmpInPTT: yupFormSchemas.object("ผู้รับผิดชอบแก้ไข", { required: (([0, 1, 2].includes(nStatusID) && sResponPerson === "26") || [3].includes(nStatusID) && IsRoleDM) && sTypeResponPerson === "23" ? true : false }),     //ผจ.ส่วน
        oUnitExternalPTT: yupFormSchemas.object("บุคคล", { required: sTypeResponPerson === "24" ? true : false }),
        sExternalPTT: yupFormSchemas.string("หน่วยงาน (อื่นๆ)", { required: IsOtherExternalPTT }),
        //4
        oStatus: yupFormSchemas.object("สถานะ", { required: false }),
        //5
        sSolution: yupFormSchemas.string("แนวทางการแก้ไข", { required: false }),
        //6
        sResolveDetail: yupFormSchemas.string("รายละเอียดการแก้ไข", { required: ["15", "16"].includes(sStatusForm) ? true : false }),
        //7
        sPlanDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
        //8
        //Reject ผจ.ส่วน
        sResolveRequestDetail: yupFormSchemas.string("รายละเอียด", { required: IsRoleDM && [3].includes(nStatusID) ? false : (([3, 19, 20].includes(nStatusID) && IsEmpRespon) || ([3].includes(nStatusID) && IsBAowner)) && objPermission?.ResolveRequest?.isShow == true ? true : false }),   //คนในหน่วยงานด้วยน่าาาา
        // sResolveRequestDetail: yupFormSchemas.string("รายละเอียด", { required: IsRoleDM && [3].includes(nStatusID) ? false : ([3, 19, 20].includes(nStatusID) && (IsEmpRespon || IsBAowner && ["23","24"].includes(sTypeResponPerson)) && objPermission?.ResolveRequest?.isShow == true) ? true : false }),   //คนในหน่วยงานด้วยน่าาาา
    }

    const schema = yup.object().shape(Object.assign(objSchema, schemaObj));
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    //#endregion

    useEffect(() => {
        GetUserData();
        //Get Data for update
        form.setValue("sTypeResponPerson", "22")
        form.setValue("sResponPerson", "25")
        const urlParams = new URLSearchParams(location.search);
        const sParamVOCFormID = urlParams.get("strMail");
        let sParamVOCID = "";
        let IsFromMail = false;
        if ((location?.state && location?.state["sVOCFormID"])) {
            sParamVOCID = location?.state["sVOCFormID"];
            setsVOCFormID(location?.state["sVOCFormID"])
            IsFromMail = false;
        }
        else if (sParamVOCFormID) {
            sParamVOCID = sParamVOCFormID;
            setsVOCFormID(sParamVOCFormID)
            IsFromMail = true;
        }

        if (sParamVOCFormID != "") {
            secureLocalStorage.removeItem("LinkTo");
            secureLocalStorage.removeItem("sUserType");
            GetScoreQueationair(sParamVOCID);
            GetDataVOCID(sParamVOCID);
            CheckPermissionVOC(IsFromMail, sParamVOCID);
            GetBAByProduct(sParamVOCID);
        }
    }, [location?.state])

    useEffect(() => {
        if (arrFileResolveRequest.length == 1) {
            onAddResolveRequest2Table()
        }
    }, [arrFileResolveRequest])

    useEffect(() => {
        if (arrFileResolve.length == 1) {
            onAddResolve2Table()
        }
    }, [arrFileResolve])

    const GetBAByProduct = (sParamVOCFormID) => {
        AxiosGet("BAService/GetBAByProduct", { "sVOCFormID": sParamVOCFormID }, (res) => {

            ResultAPI(res, null, () => {
                setlstPrd_BA(res?.result?.data || [])
                var IsDefault = res.result?.data?.filter(f => f.IsDefault == true);

                if (IsDefault != null && IsDefault.length > 0) {
                    form.setValue("oBA", IsDefault || {})
                } else {
                    form.setValue("oBA", res.result?.data[0] || {})
                }
            })
        })
    };

    //Get data Form
    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                let lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                //เช็คแค่นี้ไม่พอ ไม่ในหน่วยงานที่หมอบหมายด้วย
                // setIsRoleDM(res.result.sPISRole == "DM" ? true : false)
                setDataUser({
                    "nUserID": res.result.nUserID || "",
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                    "lstRoleUser": res.result.lstRole || []
                });
            })
        })
    };


    const GetOptiontEditFormVOCAll = async (Result) => {
        BlockUI();

        let oOptionVOC = {
            lstBA: [],
            lstCompany: [],
            lstCompanyAddress: [],
            lstVOCType: [],
            lstVOCService: [],
            lstTel: [],
            lstContactType: [],
            lstOutPTT: [],
            lstTypeResolve: [],
            lstTypeRequest: [],
            lstReqInprogress: [],
            lstTypeResponPerson: [],
            lstResponPerson: [],
            lstStatus: [],
        };

        if (Result?.objCustomer && Result?.objCustomer?.value) {
            AxiosGet(`User/GetUserTelById`, { "nUserID": Result?.objCustomer?.value, "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstTel: res.result?.data || [] }

                })
            });

            // nBAID //follow login
            AxiosPost(`Company/SearchCompany`, { "nBAID": DataUser.lstUserBA, "sLanguage": "th", "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstCompany: res.result?.data || [] }

                })
            });

        }

        if (Result.objVOCType?.value && Result.objOwnerBA?.value) {
            let nVOCTypeID = parseInt(Result.objVOCType?.value)
            let nBAID = parseInt(Result.objOwnerBA?.value)
            if (!Number.isNaN(nBAID)) {
                AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID, "IsAdd": false }, (res) => {
                    ResultAPI(res, null, () => {
                        oOptionVOC = { ...oOptionVOC, lstVOCService: res.result?.data || [] }
                        // setOption({ ...Option, lstVOCService: res.result?.data || [] })
                    })
                });
            }
        }

        if (Result.objCompany && Result?.objCompany?.value) {
            AxiosGet(`Company/GetCompanyAddress`, { "nUserID": parseInt(Result?.objCustomer?.value), "nCompanyID": Result?.objCompany?.value, "IsAdd": true }, (res) => {
                ResultAPI(res, null, () => {
                    oOptionVOC = { ...oOptionVOC, lstCompanyAddress: res.result?.data || [] }

                })
            });

            if (Result?.objCustomer && Result?.objCustomer?.value) {
                AxiosGet(`BAService/GetBA`, { "nCompanyID": Result?.objCompany?.value, "nCustomerID": Result?.objCustomer?.value, "IsSuggestion": false }, (res) => {
                    ResultAPI(res, null, () => {
                        oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }
                        if (res.result?.data.length == 1) {
                            form.setValue("oBA", res.result?.data[0] || {})
                        }
                    })
                });
            }
        }

        //#region  New
        await AxiosGet(`BAService/GetBAType`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCType: res.result?.data || [] }
            })
        });
        await AxiosGet(`BAService/GetContactType`, {}, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstContactType: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 4 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeRequest: res.result.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 6 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTypeResponPerson: res.result?.data || [] }
            })
        });
        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 7 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstResponPerson: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 8 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstOutPTT: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetStatusCreateVOC`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstStatus: res.result?.data || [] }
            })
        });
        //#endregion

        await onSetOption(oOptionVOC);

    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
        UnBlockUI();

    }

    const CheckPermissionVOC = (IsFromMail, sParamVOCFormID) => {
        //view มาจาก VOC จะแสดงแค่  3 อันแรก
        if ((location.state && location.state["sFrom"] != "myvoc") || IsFromMail) {
            BlockUI();
            AxiosGet(`VOC/CheckPermissionVOC`, { sVOCFormID: sParamVOCFormID }, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    setobjPermission(res.oProductService)
                    setsMode(res.sMode)
                })
            })
        }
        else if (location.state && location.state["sFrom"] == "myvoc") {
            //ถ้ามาจากหน้า สร้างใบงานจะ disable จำลองตรงนี้ไปเลย แก้ง่าย
            setobjPermission({ ...objPermission, ...{ Responsible: { isShow: true, isDisable: true, isEdit: false } } })
        }
    }

    const GetScoreQueationair = (sParamVOCFormID) => {
        BlockUI();
        AxiosGet(`VOC/GetScoreQueationair`, { sVOCFormID: sParamVOCFormID, "sLanguage": "th" }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                setobjScore({
                    lstQ: res.Result || [],
                    sSuggestion: res.sSuggestion,
                    isShow: res.isShow,
                })
            })
        })
    }

    const GetDataVOCID = async (sParamVOCFormID) => {
        BlockUI();
        await onSaveFlowRead(sParamVOCFormID);
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sParamVOCFormID }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                setIsEmpRespon(res.IsEmpRespon)
                setIsEmpResponVOC(res.IsEmpResponVOC)
                setIsBAowner(res.IsBAowner)
                setIsSuperAdmin(res.IsSuperAdmin)
                setIsBAAdmin(res.IsBAAdmin)
                setIsRoleDM(res.IsRoleDM)
                setIsRoleVP(res.IsRoleVP)
                let Result = res?.result?.data
                if (Result != null) {
                    await GetOptiontEditFormVOCAll(Result)

                    setsCustomerType(Result.sCustomerType)
                    setnStatusID(Result.nStatusID)
                    setnHistoryStatusID(Result.nHistoryStatusID)

                    //1
                    form.setValue("sJobCode", Result.sJobCode)
                    form.setValue("sVOCFormCode", Result.sVOCFormCode)
                    form.setValue("sReferVOCFormCode", Result.oRefVOCCode?.label == null ? null : Result.oRefVOCCode)
                    form.setValue("oCustomer", Result.objCustomer?.label == null ? null : Result.objCustomer)
                    setsCustomer(Result?.objCustomer?.label ?? "")
                    if (!([1, 2].includes(Result.nStatusID))) {
                        form.setValue("oBA", Result.objOwnerBA?.label == null ? null : Result.objOwnerBA)
                    }

                    form.setValue("oCompany", Result.objCompany?.label == null ? null : Result.objCompany)
                    form.setValue("oAddress", Result.objAddr?.label == null ? null : Result.objAddr)

                    form.setValue("sDetail", Result.sDetail)
                    form.setValue("oTel", Result.objTel?.label == null ? null : Result.objTel)
                    setIsCheckTel(Result.IsAllowContact)
                    //dIssueDate
                    let dIssueDate = moment(Result.dIssueDate);
                    let dTimeIssue = dIssueDate.format("HH:mm");
                    form.setValue("sDateIssue", dIssueDate)
                    // form.setValue("sTimeIssue", dTimeIssue)
                    form.setValue("sTimeIssue", dIssueDate)
                    setIsAllowEmailAlert(Result.IsAllowEmailAlert ?? false)

                    // form.setValue("sNoticeEmail", Result.IsAllowEmailAlert != false ? "1" : "0")
                    form.setValue("sNoticeEmail", Result.IsAllowEmailAlert == true ? "1" : "0")
                    form.setValue("sEmail", Result.sEmail)
                    form.setValue("sFname", Result.sExternal_FName)
                    form.setValue("sLname", Result.sExternal_LName)
                    form.setValue("sCompany", Result.sExternal_CompanyName)
                    form.setValue("sAddress", Result.sExternal_Address)
                    form.setValue("sInputTel", Result.sExternal_Tel)
                    form.setValue("sInputTelExtension", Result.sExternal_Tel_Extension)
                    setIsAddTelExtentionGuest(Result.sExternal_Tel_Extension !== null && Result.sExternal_Tel_Extension !== "")

                    form.setValue("sDetail", Result.sDetail)
                    //2

                    let objFormData = Result.objFormData;
                    form.setValue("oTypeRequest", objFormData.objRequestType?.label == null ? null : objFormData.objRequestType)
                    form.setValue("sRequestTypeOther", objFormData.sRequestTypeOther ?? null)
                    setIsOtherRequest(Result?.objRequestType?.IsOther == true ? true : false)
                    //3
                    let sTypeResponPerson = objFormData.nResponsibleTypeID ? objFormData.nResponsibleTypeID + "" : "22";
                    let sResponPerson = objFormData.nResponsibleID ? objFormData.nResponsibleID + "" : "25";
                    form.setValue("sTypeResponPerson", sTypeResponPerson)
                    form.setValue("sResponPerson", sResponPerson)
                    setsTypeResponPerson(sTypeResponPerson)
                    setsResponPerson(sResponPerson)

                    form.setValue("oAutoUnitInGBU", objFormData.objResponsibleUnit?.label == null ? null : objFormData.objResponsibleUnit)
                    form.setValue("oAutoEmpInGBU", objFormData.objResponsibleEmp?.label == null ? null : objFormData.objResponsibleEmp)
                    form.setValue("oAutoUnitInPTT", objFormData.objResponsibleUnit?.label == null ? null : objFormData.objResponsibleUnit)
                    form.setValue("oAutoEmpInPTT", objFormData.objResponsibleEmp?.label == null ? null : objFormData.objResponsibleEmp)
                    setIshaveResponEmp(objFormData.objResponsibleEmp?.label == null ? false : true)

                    form.setValue("oUnitExternalPTT", Result.objOtherPTT?.label == null ? null : Result.objOtherPTT)
                    form.setValue("sExternalPTT", Result.sOtherPTT ?? null)

                    setIsReferVOC(Result.isReferVOC ?? false)
                    setIsCreateByBA(Result.isCreateByBA ?? false)

                    setDataRowResolveRequest(Result.lstRequestTypeFile || [])
                    setDataRowProDuctService(Result.lstProduct || [])
                    //4
                    if ([7, 8, 20].includes(Result.nStatusID)) {
                        form.setValue("sResolveRequestDetail", objFormData.sResloveDetail + "")
                    }
                }

            })
        })
    }

    const onHandleField = async (eventValue, sField) => {
        if (sField === "Customer") {
            //กรอง หมายเลขโทรศัพท์ 
            if (eventValue && eventValue.value) {
                let lstTEL = [] as any;
                let lstCompany = [] as any;

                AxiosGet(`User/GetUserTelById`, { "nUserID": eventValue.value, "IsAdd": true }, (res) => {
                    ResultAPI(res, null, () => {
                        lstTEL = res.result?.data || [];
                        setOption({ ...Option, lstTel: lstTEL })
                    })
                });

                // nBAID //follow login
                AxiosPost(`Company/SearchCompany`, { "nBAID": DataUser.lstUserBA, "sLanguage": "th", "IsAdd": true }, (res) => {
                    ResultAPI(res, null, () => {
                        lstCompany = res.result?.data || [];
                        setOption({ ...Option, lstTel: lstTEL, lstCompany: lstCompany })
                    })
                });

            }
        }
        else if (sField === "BA") {
            //กรอง บริษัท
            if (eventValue?.value) {
                if (form.getValues("oVOCType")) {
                    let nVOCTypeID = form.getValues("oVOCType") ? parseInt(form.getValues("oVOCType").value) : 0
                    let nBAID = parseInt(eventValue.value) ?? 0
                    if (!Number.isNaN(nBAID)) {
                        // AxiosGet(`BAService/GetBAService`, { "nVOCTypeID": nVOCTypeID }, (res) => {
                        AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID, "IsAdd": false }, (res) => {
                            ResultAPI(res, null, () => {
                                setOption({ ...Option, lstVOCService: res.result?.data || [] })
                            })
                        });
                    }

                }
            }
        }
        else if (sField === "Company") {
            //กรอง สถานที่
            let oCustomer = form.getValues("oCustomer")

            if (eventValue && eventValue.value) {

                let lstCompanyAddress = [] as any;
                let lstBA = [] as any;

                AxiosGet(`Company/GetCompanyAddress`, { "nUserID": parseInt(oCustomer?.value), "nCompanyID": eventValue.value, "IsAdd": true }, (res) => {
                    ResultAPI(res, null, () => {
                        lstCompanyAddress = res.result?.data || []
                        setOption({ ...Option, lstCompanyAddress: lstCompanyAddress })
                    })
                });
                //Default BA
                if (oCustomer) {
                    AxiosGet(`BAService/GetBA`, { "nCompanyID": eventValue.value, "nCustomerID": oCustomer.value, "IsSuggestion": false }, (res) => {
                        ResultAPI(res, null, () => {
                            lstBA = res.result?.data || [];
                            setOption({ ...Option, lstCompanyAddress: lstCompanyAddress, lstBA: lstBA })
                            if (res.result?.data.length == 1) {
                                form.setValue("oBA", res.result?.data[0] || {})
                            }
                        })
                    });
                }

            }
        }
        else if (sField === "TypeVOC") {
            //กรอง ปัญหาที่พบ
            if (eventValue && eventValue.value) {
                let nBAID = form.getValues("oBA") ? parseInt(form.getValues("oBA").value) : 0
                let nVOCTypeID = parseInt(eventValue.value) ?? 0
                if (!Number.isNaN(nBAID)) {
                    // AxiosGet(`BAService/GetBAService`, { "nVOCTypeID": nVOCTypeID }, (res) => {
                    AxiosGet(`BAService/GetBAService`, { "nBAID": nBAID, "nVOCTypeID": nVOCTypeID }, (res) => {
                        ResultAPI(res, null, () => {
                            setOption({ ...Option, lstVOCService: res.result?.data || [] })
                        })
                    });
                }
            }
        }
    }
    const onSaveFlowRead = async (sParamVOCFormID) => {
        let oParam = {
            "sVOCFormID": sParamVOCFormID,
            "sMode": "R",
        }
        if (sParamVOCFormID != "") {
            await AxiosPost(`VOC/SaveVOCFormData`, oParam, (res) => {
                ResultAPI(res, null, () => {
                })
            }, null, null)
        }
    }
    //Submit Form

    const onSubmitProductService = (statusMode = "O") => {

        let sMessage = "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?"
        let IsConfirm = true;

        let { sResponsibleUnitAbbr, sResponsibleUnitCode, sResponsibleUnitName, sResponsibleEmpCode, nExternalPTTUnitID, sExternalPTTOther } = onCheckDataResponPIS(form, nStatusID, IsRoleDM, IsEmpResponVOC);

        if (form.getValues("oStatus")) {
            sMessage = "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?"

            let nStatusIDForm = parseInt(form.getValues("oStatus").value);
            //15 แก้ไขแล้ว  16 ปิดแล้ว
            if (nStatusIDForm === 12) {
                statusMode = sResponPerson == "25" ? "O" : "I";
            } else if (nStatusIDForm === 15) {
                statusMode = "RS";
                sMessage = "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?"
                // sMessage = nStatusID == 2 ? "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?" : "คุณต้องการที่จะยืนยันการดำเนินการตามข้อร้องขอใช่หรือไม่ ?"

                //เช็คว่าเป็น unit หรือเปล่า ถ้าใช่ให้บังคับกรอกชื่อผู้รับผิดชอบแก้ไข
                if (sResponPerson == "25" && sTypeResponPerson == "22") {
                    IsConfirm = false
                    sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข ประเภทบุคคล"
                    setnAlertCount(0)
                }
                // if (sResponPerson == "25" && sTypeResponPerson == "23" && nAlertCount < 1) {
                //     IsConfirm = false
                //     setnAlertCount(nAlertCount + 1)
                //     sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข, หากไม่ทราบพนักงานที่รับผิดชอบการแก้ไขกรุณาระบุข้อมูลหน่วยงานที่รับผิดชอบ"
                // }

            } else {
                // sMessage = "คุณต้องการที่จะบันทึกและปิดใบงานใช่หรือไม่ ?"
                statusMode = "C";

                //เช็คว่าเป็น unit หรือเปล่า ถ้าใช่ให้บังคับกรอกชื่อผู้รับผิดชอบแก้ไข
                if (sResponPerson == "25" && sTypeResponPerson == "22") {
                    IsConfirm = false
                    sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข ประเภทบุคคล"
                    setnAlertCount(0)
                }
                // if (sResponPerson == "25" && sTypeResponPerson == "23" && nAlertCount < 1) {
                //     IsConfirm = false
                //     setnAlertCount(nAlertCount + 1)
                //     sMessage = "กรุณากรอกข้อมูลผู้รับผิดชอบแก้ไข, หากไม่ทราบพนักงานที่รับผิดชอบการแก้ไขกรุณาระบุข้อมูลหน่วยงานที่รับผิดชอบ"
                // }
            }
        }
        else if (nStatusID == 3) {
            //Request มีแต่ ผจ.ส่วน
            sMessage = IsRoleDM ? "คุณต้องการที่จะยืนยันใช่หรือไม่ ?" : "คุณต้องการที่จะยืนยันและดำเนินการตามข้อร้องขอใช่หรือไม่ ?";
            statusMode = IsRoleDM ? "I" : "RS";
            if (nHistoryStatusID == 17) {
                sMessage = "คุณต้องการที่จะบันทึกและเปิดใบงานใช่หรือไม่ ?";
                statusMode = "O";
            }
        }
        else if (nStatusID == 19 || nStatusID == 20) {
            //สำหรับคนรับผิดชอบหรือคนที่เข้ามาแก้ไข
            sMessage = "คุณต้องการที่จะยืนยันการดำเนินการตามข้อร้องขอใช่หรือไม่ ?"
        }

        if (statusMode == "D") {
            sMessage = "คุณต้องการที่จะบันทึกร่างใช่หรือไม่ ?"
        }

        if (IsConfirm) {
            let param = {
                "sVOCFormID": sVOCFormID,
                "nJobTypeID": 2,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
                "sMode": statusMode,
                "cCustomerType": "E",
                "nVOCFormTypeID": 2,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
                "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
                "nCustomerID": form.getValues("oCustomer") ? parseInt(form.getValues("oCustomer").value) : null,
                "sDetail": form.getValues("sDetail") ?? null,
                "nTelID": form.getValues("oTel") ? parseInt(form.getValues("oTel").value) : null,
                "IsAllowContact": IsCheckTel,
                "nAddrID": form.getValues("oAddress") ? parseInt(form.getValues("oAddress").value) : null,
                "nContactTypeID": form.getValues("oNoticeChannel") ? parseInt(form.getValues("oNoticeChannel").value) : null,
                "dIssueDate": form.getValues("sDateIssue") && form.getValues("sTimeIssue") ? new Date(moment(form.getValues("sDateIssue")).format("YYYY-MM-DD") + " " + moment(form.getValues("sTimeIssue")).format("HH:mm")) : null,
                "sIssueDate": form.getValues("sDateIssue") && form.getValues("sTimeIssue") ? moment(form.getValues("sDateIssue")).format("DD/MM/YYYY") + " " + moment(form.getValues("sTimeIssue")).format("HH:mm") : null,
                "IsAllowEmailAlert": form.getValues("sNoticeEmail") && form.getValues("sNoticeEmail") === "1" ? true : false,
                "IsCreateVOCByBA": true,
                "sRefVOCCode": form.getValues("sReferVOCFormCode") ? form.getValues("sReferVOCFormCode").label : null,
                "nOwnerBAID": form.getValues("oBA") ? parseInt(form.getValues("oBA").value) : null,
                "nVOCTypeID": form.getValues("oVOCType") ? parseInt(form.getValues("oVOCType").value) : null,
                "nVOCServiceID": form.getValues("oVOCService") ? parseInt(form.getValues("oVOCService").value) : null,
                "sVOCServiceOther": form.getValues("sOtherVOCService") ?? null,
                "objFormData": {
                    "sVOCFormID": sVOCFormID,
                    "nRequestTypeID": form.getValues("oTypeRequest") ? parseInt(form.getValues("oTypeRequest").value) : null,
                    "sRequestTypeOther": form.getValues("sRequestTypeOther") ?? null,

                    "nResponsibleTypeID": form.getValues("sTypeResponPerson") ? parseInt(form.getValues("sTypeResponPerson")) : null,
                    "nResponsibleID": form.getValues("sResponPerson") ? parseInt(form.getValues("sResponPerson")) : null,
                    "sResponsibleUnitAbbr": sResponsibleUnitAbbr,
                    "sResponsibleUnitCode": sResponsibleUnitCode,
                    "sResponsibleUnitName": sResponsibleUnitName,

                    "sResponsibleEmpCode": sResponsibleEmpCode,
                    "nExternalPTTUnitID": nExternalPTTUnitID,
                    "sExternalPTTOther": sExternalPTTOther,

                    "nSolutionTypeID": null,    //flow
                    "sResloveDetail": form.getValues("sResolveRequestDetail") ? form.getValues("sResolveRequestDetail") : form.getValues("sResolveDetail"),     //flow
                    "sPlanDetail": null         //flow
                },
                "objFormFile": arrAttachment || [],
                "objRequestTypeFile": DataRowResolveRequest.length > 0 ? DataRowResolveRequest : (DataRowResolve.length > 0 ? DataRowResolve : []),
            }
            SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
                BlockUI();
                AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                    ResultAPI(res, null, () => {
                        if (res.statusCode === 200) {
                            setIsOpenSnackbar(true);
                            let sHTML = statusMode == "D" ? <><p>บันทึกข้อมูลสำเร็จ</p></> : <><p>บันทึกข้อมูลสำเร็จ</p><p>เลขที่ใบงาน: {res?.result?.sJobCode}</p></>
                            setsMessageSnackbar(sHTML)
                            setsSeveritySnackbar("success")
                            BlockUI();
                            setTimeout(() => {
                                UnBlockUI();
                                onGotoBack();
                            }, 2000)
                        }
                        else {
                            setIsOpenSnackbar(true);
                            setsMessageSnackbar(res.Message)
                            setsSeveritySnackbar("warning")
                            UnBlockUI();
                        }
                    })
                }, null, null)
            })
        } else {
            SwAlert.Warning(AlertTitleTh.Warning, sMessage, () => {
                setsResponPerson("26")
                form.setValue("oAutoEmpInGBU", null)
                form.setValue("sResponPerson", "26")
            })
        }
    }

    //#region   For component Resolve
    const onAddResolveRequest2Table = () => {

        let arrResolveRequest = [];
        (DataRowResolveRequest || []).forEach(val => arrResolveRequest.push(Object.assign({}, val)));
        // let Id = DataRowResolveRequest.length > 0 ? (Math.max.apply(Math, DataRowResolveRequest.map(function (o) { return o.nRow; }))) + 1 : 1
        let nIDMAX = DataRowResolveRequest.length > 0 ? (Math.max.apply(Math, DataRowResolveRequest.map(function (o) { return o.sID; }))) + 1 : 1
        let nRowMAX = DataRowResolveRequest.length > 0 ? (Math.max.apply(Math, DataRowResolveRequest.map(function (o) { return o.nRow; }))) + 1 : 1

        arrResolveRequest.push({
            "sID": nIDMAX,
            "nRow": nRowMAX,
            "sFileName": arrFileResolveRequest.length > 0 ? arrFileResolveRequest[0]?.sFileName : null,
            "sFileID": arrFileResolveRequest.length > 0 ? arrFileResolveRequest[0]?.sFileID : null,
            "sFileType": arrFileResolveRequest.length > 0 ? arrFileResolveRequest[0]?.sFileType : null,
            "sFileLink": arrFileResolveRequest.length > 0 ? arrFileResolveRequest[0]?.sFileLink : null,
            "sPath": arrFileResolveRequest.length > 0 ? arrFileResolveRequest[0]?.sPath : null,
            "sSysFileName": arrFileResolveRequest.length > 0 ? arrFileResolveRequest[0]?.sSysFileName : null,
            "sNoteID": null,
            "IsNew": true,
            "IsDelete": false
        })
        setDataRowResolveRequest(arrResolveRequest)
        //Add success to clear data
        onClearFileResolveRequest.current(null)
    }

    const onDeleteArrResolveRequest = (itemRow) => {
        let arrResolveRequest = [];
        (DataRowResolveRequest || []).forEach(val => arrResolveRequest.push(Object.assign({}, val)));
        let findindx = arrResolveRequest.findIndex(f => f.nRow == itemRow.nRow);
        if (findindx != -1) {
            arrResolveRequest[findindx].IsDelete = true;
            let arrTotal = arrResolveRequest.filter(f => f.IsDelete == false);
            if (arrTotal.length > 0) {
                let nID = 1;
                arrTotal.forEach(element => {
                    element.nRow = nID;
                    nID++;
                });
            }
            setDataRowResolveRequest(arrTotal)
        }

    }
    //#endregion
    //#region   For component Resolve
    const onAddResolve2Table = () => {

        let arrResolve = [];
        (DataRowResolve || []).forEach(val => arrResolve.push(Object.assign({}, val)));
        let Id = arrResolve.length > 0 ? (Math.max.apply(Math, arrResolve.map(function (o) { return o.nRow; }))) + 1 : 1
        arrResolve.push({
            "sID": Id,
            "nRow": Id,
            "sFileName": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileName : null,
            "sFileID": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileID : null,
            "sFileType": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileType : null,
            "sFileLink": arrFileResolve.length > 0 ? arrFileResolve[0]?.sFileLink : null,
            "sPath": arrFileResolve.length > 0 ? arrFileResolve[0]?.sPath : null,
            "sSysFileName": arrFileResolve.length > 0 ? arrFileResolve[0]?.sSysFileName : null,
            "sNoteID": null,
            "IsNew": true,
            "IsDelete": false
        })
        setDataRowResolve(arrResolve)
        //Add success to clear data
        onClearFileResolve.current(null)
    }

    const onDeleteArrResolve = (itemRow) => {
        let arrResolve = [];
        (DataRowResolve || []).forEach(val => arrResolve.push(Object.assign({}, val)));
        let findindx = arrResolve.findIndex(f => f.nRow == itemRow.nRow);
        if (findindx != -1) {
            arrResolve[findindx].IsDelete = true;
            let arrTotal = arrResolve.filter(f => f.IsDelete == false);
            setDataRowResolve(arrTotal)
        }
    }
    //#endregion
    const onGotoBack = () => {
        let sUrl = -1 as any;
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const strMail = urlParams.get("strMail");
        
        if(strMail != null && strMail != "")
        {
            sUrl = "/Backend/HomeBackEnd";
        }
        navigate(sUrl);

    }

    const onGotoLiveChat = async () => {

        //Create nChatID 
        let nChatID = 0;
        await AxiosGet(`VOC/GetCreateChatID`, { "sVOCFormID": sVOCFormID }, (res) => {
            ResultAPI(res, null, () => {
                nChatID = res.nChatID;
            })
        });

        await GotoChat(nChatID);

    }

    const GotoChat = async (nChatID) => {
        let StrUrl = "/Backend/LiveChat";
        navigate(StrUrl,
            {
                state:
                {
                    sVOCFormID: sVOCFormID,
                    nChatID: nChatID
                }
            }
        );
    }

    const JsxBoxChat = () => {
        if (nStatusID != 8) {
            return (
                <>
                    {
                        (objPermission?.IsShowChat || location?.state?.sFrom == "myvoc") && sCustomerType == "E"
                            ?
                            <Grid item xs={6} md={12} xl={12}>
                                <CardBox
                                    icon={<AiFillWechat style={{ fontSize: '2.5em', color: '#11c990' }} />}
                                    label={"Chat"}
                                    subLabel={sCustomer}
                                    onClick={() => { onGotoLiveChat() }}
                                    classCard={"button-chat"}
                                />
                            </Grid>
                            : null
                    }
                    {
                        (objPermission?.IsShowInformInprogress) && sCustomerType == "E" ?
                            <Grid item xs={6} md={12} xl={12}>
                                <CardBox
                                    icon={<FaBell style={{ fontSize: '2em', color: '#11c990' }} />}
                                    label={"แจ้งความก้าวหน้า"}
                                    onClick={() => { setIsOpenModalInform(true) }}
                                    classCard={"button-chat"}
                                    style={{
                                        height: '46px'
                                    }}
                                />
                            </Grid>
                            : null
                    }
                    {
                        objPermission?.IsShowWorkFlowHis || location?.state?.sFrom == "myvoc" ?
                            <Grid item xs={6} md={12} xl={12}>
                                <CardBox
                                    icon={<ChatRoundedIcon style={{ fontSize: '2em', color: '#237ce0' }} />}
                                    label={"Workflow History"}
                                    onClick={() => { setIsOpenModalWorkFlowHis(true) }}
                                    classCard={"button-wfHis"}
                                    style={{
                                        height: '46px'
                                    }}
                                />
                            </Grid>
                            : null
                    }
                </>
            )
        }
        else if (nStatusID == 8) {
            return (
                <>
                    <Grid item xs={6} md={12} xl={12}>
                        <CardBox
                            icon={<ChatRoundedIcon style={{ fontSize: '2em', color: '#237ce0' }} />}
                            label={"Workflow History"}
                            onClick={() => { setIsOpenModalWorkFlowHis(true) }}
                            classCard={"button-wfHis"}
                            style={{
                                height: '46px'
                            }}
                        />
                    </Grid>
                </>
            )
        }
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<BiEdit style={{ fontSize: '1.5em' }} />}
                labal_Head="สร้างใบงาน"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginTop: '0' }}>
                <Grid item xs={12} md={nStatusID != 0 && sVOCFormID != null && Layout1300 ? 10 : 12}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        {
                            (nStatusID == 3 && IsRoleDM && !IsEmpResponVOC) ?
                                <Grid item xs={12} > {/** ข้อมูลผู้รับผิดชอบแก้ไข */}
                                    <FormProvider {...form}>
                                        <CpnResponPersonNew
                                            form={form}
                                            Option={Option}
                                            nStatusID={nStatusID}
                                            IsRoleDM={IsRoleDM}
                                            IsRoleVP={IsRoleVP}
                                            sMode={sMode}
                                            sTypeResponPerson={sTypeResponPerson}
                                            setsTypeResponPerson={setsTypeResponPerson}
                                            sResponPerson={sResponPerson}
                                            setsResponPerson={setsResponPerson}
                                            setIsOtherExternalPTT={setIsOtherExternalPTT}
                                            IshaveResponEmp={IshaveResponEmp}
                                            objPermission={objPermission}
                                            nHistoryStatusID={nHistoryStatusID}

                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        {/* Button Action */}
                        {
                            (nStatusID == 3 && IsRoleDM && !IsEmpResponVOC) ?
                                <Grid item xs={12} > {/** ข้อมูลจำแนกประเภทข้อร้องเรียน */}
                                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                        {
                                            objPermission?.IsBtnRejectDM ?
                                                <Grid item>
                                                    {/* ผจ.ส่วน */}
                                                    <BtnRejectPart txt={"ไม่ยอมรับข้อร้องขอ"} onClick={() => { form.clearErrors(); setIsOpenRejectPart(true); }} />
                                                </Grid>
                                                : null
                                        }
                                        {
                                            objPermission?.IsBtnSaveDM ?
                                                <Grid item>
                                                    {/* ผจ.ส่วน */}
                                                    <BtnSave txt={"ยืนยัน"} onClick={form.handleSubmit(() => { onSubmitProductService() })} />
                                                </Grid>
                                                : null
                                        }
                                        <Grid item>
                                            <BtnBack onClick={() => { onGotoBack() }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                : null
                        }
                        <Grid item xs={12}> {/**  */}
                            <FormProvider {...form}>
                                <CpnDataProductService
                                    form={form}
                                    header={"ข้อมูลผู้ติดต่อ"}
                                    Option={Option}
                                    setIsCheckTel={setIsCheckTel}
                                    IsCheckTel={IsCheckTel}
                                    lstPrd_BA={lstPrd_BA}
                                    onHandleField={onHandleField}
                                    nStatusID={nStatusID}
                                    sMode={sMode}
                                    objPermission={objPermission}
                                    sCustomerType={sCustomerType}
                                    setisInputTelRequireGuest={setisInputTelRequireGuest}
                                    IsAddTelExtentionGuest={IsAddTelExtentionGuest}
                                    setIsAddTelExtentionGuest={setIsAddTelExtentionGuest}
                                />
                            </FormProvider>
                        </Grid>
                        <Grid item xs={12} > {/** ข้อมูลจำแนกประเภทข้อร้องเรียน */}
                            <CpnListProductService
                                DataRowProductService={DataRowProductService}
                                objPermission={objPermission}
                            />
                        </Grid>
                        <Grid item xs={12} > {/** ข้อมูลจำแนกประเภทข้อร้องเรียน */}
                            <FormProvider {...form}>
                                <CpnTypeRequest
                                    form={form}
                                    Option={Option}
                                    nStatusID={nStatusID}
                                    sMode={sMode}
                                    objPermission={objPermission}
                                    IsOtherRequest={IsOtherRequest}
                                    setIsOtherRequest={setIsOtherRequest}
                                />
                            </FormProvider>
                        </Grid>
                        {
                            !(nStatusID == 3 && IsRoleDM && !IsEmpResponVOC) ?
                                <Grid item xs={12} > {/** ข้อมูลผู้รับผิดชอบแก้ไข */}
                                    <FormProvider {...form}>
                                        <CpnResponPersonNew
                                            form={form}
                                            Option={Option}
                                            nStatusID={nStatusID}
                                            IsRoleDM={IsRoleDM}
                                            IsRoleVP={IsRoleVP}
                                            sMode={sMode}
                                            sTypeResponPerson={sTypeResponPerson}
                                            setsTypeResponPerson={setsTypeResponPerson}
                                            sResponPerson={sResponPerson}
                                            setsResponPerson={setsResponPerson}
                                            setIsOtherExternalPTT={setIsOtherExternalPTT}
                                            IshaveResponEmp={IshaveResponEmp}
                                            objPermission={objPermission}
                                            nHistoryStatusID={nHistoryStatusID}
                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        {
                            objPermission?.Note?.isShow == true ?
                                <Grid item xs={12} >
                                    <CpnNote
                                        sVOCFormID={sVOCFormID}
                                        nStatusID={nStatusID}
                                        sMode={sMode}
                                        objPermission={objPermission}
                                    />
                                </Grid>
                                : null
                        }
                        {
                            (objPermission?.Status?.isShow == true || [0, 1, 2].includes(nStatusID)) && (DataUser.lstRoleUser.includes(2) || DataUser.lstRoleUser.includes(3)) ?
                                <Grid item xs={12} >
                                    <FormProvider {...form}>
                                        <CpnStatusVOC
                                            form={form}
                                            Option={Option}
                                            DataRowResolve={DataRowResolve}
                                            arrFileResolve={arrFileResolve}
                                            setarrFileResolve={setarrFileResolve}
                                            onAddResolve2Table={onAddResolve2Table}
                                            onDeleteArrResolve={onDeleteArrResolve}
                                            onClearFileResolve={onClearFileResolve}
                                            nStatusID={nStatusID}
                                            sMode={sMode}
                                            setsStatusForm={setsStatusForm}
                                            objPermission={objPermission}
                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        {
                            objPermission?.ResolveRequest?.isShow == true ?
                                <Grid item xs={12} >
                                    <FormProvider {...form}>
                                        <CpnTypeRequestResolve
                                            form={form}
                                            DataRowResolveRequest={DataRowResolveRequest}
                                            arrFileResolveRequest={arrFileResolveRequest}
                                            setarrFileResolveRequest={setarrFileResolveRequest}
                                            onAddResolveRequest2Table={onAddResolveRequest2Table}
                                            onDeleteArrResolveRequest={onDeleteArrResolveRequest}
                                            onClearFileResolveRequest={onClearFileResolveRequest}
                                            nStatusID={nStatusID}
                                            sMode={sMode}
                                            objPermission={objPermission}
                                        />
                                    </FormProvider>
                                </Grid>
                                : null
                        }
                        <Grid item xs={12} >
                            <FormProvider {...form}>
                                <CpnAlertEmail
                                    form={form}
                                    nStatusID={nStatusID}
                                    IsAllowEmailAlert={IsAllowEmailAlert}
                                    objPermission={objPermission}
                                    sMode={sMode}
                                    sReferFrom={"prd"}
                                />
                            </FormProvider>
                        </Grid>
                        {
                            objScore.isShow == true ?
                                <Grid item xs={12}>
                                    <Accordion header={"ข้อมูลประเมินความพึงพอใจ"}>
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                            {
                                                objScore.lstQ != null && objScore.lstQ.length > 0 ?
                                                    <>
                                                        {
                                                            (objScore.lstQ).map((element, idx) => {
                                                                return (
                                                                    <Grid item xs={12}>
                                                                        <Typography>
                                                                            {idx + 1}.&nbsp;{element.sQuestion}&nbsp;&nbsp; คะแนนที่ได้&nbsp;&nbsp;
                                                                            {element.sScore == "0" ? "0" : element.sScore == "N/A" ? "N/A" : <Rating value={element.nScore} max={element.nScore} readOnly />}

                                                                        </Typography>
                                                                    </Grid>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                    :
                                                    null
                                            }
                                            <Grid item xs={12}>
                                                <Typography style={{ fontWeight: 500 }}>
                                                    คำแนะนำติชม
                                                </Typography>
                                                <Typography >
                                                    {objScore.sSuggestion}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </Accordion>
                                </Grid>
                                :
                                null
                        }
                        <Grid item xs={12} style={{ display: nStatusID != 0 && sVOCFormID != null && !Layout1300 ? '' : 'none' }}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                <Grid item xs={12}>
                                    <VerticalStepper sVOCFormID={sVOCFormID} />
                                </Grid>
                                {JsxBoxChat()}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} style={{ display: !(nStatusID == 3 && IsRoleDM && !IsEmpResponVOC) ? "" : "none" }}>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                {
                                    objPermission?.IsBtnSaveResolve ?
                                        <Grid item>
                                            <BtnSave txt={"ยืนยันการดำเนินการตามข้อร้องขอ"} onClick={form.handleSubmit(() => { onSubmitProductService("RS") })} />
                                        </Grid>
                                        : null
                                }
                                {
                                    objPermission?.IsBtnRejectDM ?
                                        <Grid item>
                                            <BtnRejectPart txt={"ไม่ยอมรับข้อร้องขอ"} onClick={() => { form.clearErrors(); setIsOpenRejectPart(true); }} />
                                        </Grid>
                                        : null
                                }
                                {
                                    objPermission?.IsBtnSaveDM ?
                                        <Grid item>
                                            <BtnSave txt={"ยืนยัน"} onClick={form.handleSubmit(() => { onSubmitProductService() })} />
                                        </Grid>
                                        : null
                                }
                                {
                                    (objPermission?.IsBtnOpenJob || [0].includes(nStatusID)) ?
                                        <Grid item>
                                            <BtnSend txt={"บันทึกและเปิดใบงาน"} onClick={form.handleSubmit(() => { onSubmitProductService("O") })} />
                                        </Grid>
                                        : null
                                }
                                <Grid item>
                                    <BtnBack onClick={() => { onGotoBack() }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* Stepper */}
                <Grid item xs={12} md={2} style={{ display: nStatusID != 0 && sVOCFormID != null && Layout1300 ? '' : 'none' }}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                            <VerticalStepper sVOCFormID={sVOCFormID} />
                        </Grid>
                        {JsxBoxChat()}
                    </Grid>
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
            <ModalRejectPart
                form={form}
                nStatusID={nStatusID}
                IsRoleDM={IsRoleDM}
                IsOpen={IsOpenRejectPart}
                setIsOpen={setIsOpenRejectPart}
                sVOCFormID={sVOCFormID}
                nJobTypeID={2}
                setIsOpenSnackbar={setIsOpenSnackbar}
                setsSeveritySnackbar={setsSeveritySnackbar}
                setsMessageSnackbar={setsMessageSnackbar}
            />
            <ModalInformInprogress
                IsOpen={IsOpenModalInform}
                setIsOpen={setIsOpenModalInform}
                sVOCFormID={sVOCFormID}
                DataUser={DataUser}
                DataRowInprogress={DataRowInprogress}
                setDataRowInprogress={setDataRowInprogress}
            />
            <ModalWorkflowHistory
                IsOpen={IsOpenModalWorkFlowHis}
                setIsOpen={setIsOpenModalWorkFlowHis}
                sVOCFormID={sVOCFormID}
            />
        </>
    )
}

export default PageProductAndService